export default "__VITE_ASSET__50b32736__"